import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { getCompanyBranding } from '../../../services/companySettingsService';

const CompanyBranding = () => {
  const currentYear = new Date()?.getFullYear();
  const [branding, setBranding] = useState({
    companyName: 'PROPERTY APPLICATIONS',
    logoUrl: '/assets/images/Apropapplogo-1768301171635.jpg'
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadBranding();
  }, []);

  const loadBranding = async () => {
    try {
      setLoading(true);
      const data = await getCompanyBranding();
      if (data?.logoUrl || data?.companyName) {
        setBranding({
          companyName: data?.companyName || 'PROPERTY APPLICATIONS',
          logoUrl: data?.logoUrl || '/assets/images/Apropapplogo-1768301171635.jpg'
        });
      }
    } catch (error) {
      console.error('Error loading company branding:', error);
      // Keep default values on error - logo will still show
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full space-y-6 md:space-y-8">
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl flex items-center justify-center shadow-warm-lg overflow-hidden bg-black p-4">
            <img 
              src={branding?.logoUrl} 
              alt="Company Logo" 
              className="w-full h-full object-contain"
              onError={(e) => {
                console.error('Logo failed to load:', branding?.logoUrl);
                e.target.src = '/assets/images/Apropapplogo-1768301171635.jpg';
              }}
            />
          </div>
          <span className="text-sm md:text-base text-primary font-bold font-heading mt-3">
            {branding?.companyName}
          </span>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white">
            نظام إدارة العقارات
          </h1>
          <p className="text-base md:text-lg text-white/70 font-caption">
            منصة متكاملة لإدارة العقارات والعملاء
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        <div className="flex flex-col items-center text-center p-4 bg-card/50 rounded-lg">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-3">
            <Icon name="Users" size={24} color="var(--color-primary)" />
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-primary mb-1">
            ٥٠+
          </p>
          <p className="text-sm text-white/70 font-caption">
            مستخدم نشط
          </p>
        </div>

        <div className="flex flex-col items-center text-center p-4 bg-card/50 rounded-lg">
          <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center mb-3">
            <Icon name="Building" size={24} color="var(--color-secondary)" />
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-primary mb-1">
            ١٢٠٠+
          </p>
          <p className="text-sm text-white/70 font-caption">
            عقار مُدار
          </p>
        </div>

        <div className="flex flex-col items-center text-center p-4 bg-card/50 rounded-lg">
          <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mb-3">
            <Icon name="FileCheck" size={24} color="var(--color-accent)" />
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-primary mb-1">
            ٩٨٪
          </p>
          <p className="text-sm text-white/70 font-caption">
            معدل الرضا
          </p>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Icon name="Shield" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-white/70 font-caption">
            ISO 27001 معتمد
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Lock" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-white/70 font-caption">
            تشفير SSL
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-white/70 font-caption">
            GDPR متوافق
          </span>
        </div>
      </div>

      <div className="text-center pt-4">
        <p className="text-xs text-white/60 font-caption">
          © {currentYear} نظام إدارة العقارات. جميع الحقوق محفوظة.
        </p>
      </div>
    </div>
  );
};

export default CompanyBranding;